"use client"

import { PoundSterling } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `PoundSterlingIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const PoundSterlingIcon = component(Icon)({ as: PoundSterling })
